import { render, staticRenderFns } from "./hoverGrid.vue?vue&type=template&id=20b34b1e&scoped=true&"
import script from "./hoverGrid.vue?vue&type=script&lang=ts&"
export * from "./hoverGrid.vue?vue&type=script&lang=ts&"
import style0 from "./hoverGrid.vue?vue&type=style&index=0&id=20b34b1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b34b1e",
  null
  
)

export default component.exports